export const FLOW_SELECTION_SEARCH = 'FLOW_SELECTION_SEARCH'
export const FLOW_SELECTION_FETCHING = 'FLOW_SELECTION_FETCHING'
export const FLOW_SELECTION_SUCCESS = 'FLOW_SELECTION_SUCCESS'
export const FLOW_SELECTION_PAGINATION = 'FLOW_SELECTION_PAGINATION'